import { isEmpty, isNil } from 'ramda'

export function isEmptyOrNil(anything: any) {
  return isNil(anything) || isEmpty(anything)
}
